import { Meeting } from 'api';
import { AppEpic } from 'model';
import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { appMessageSuccess, appMessageError } from 'model/app';
import APP_MESSAGE from 'constant/message';
import { filter, mergeMap, startWith, catchError } from 'rxjs/operators';
import {
  getUnreadCount,
  getInitiatedMeeting,
  getReceivedMeeting,
  setUnReadCount,
  setInitiatedMeeting,
  setReceivedMeeting,
  setReceivedMeetingLoading,
  setInitiatedMeetingLoading,
  getReceivedMeetingDetail,
  setReceivedMeetingDetail,
  doApprovalMeeting,
  setApprovalMeetingRead,
  setLocaleApprovalMeetingRead,
  gotoApprovalMeetingDetail,
  setInitiatedMeetingDetail,
  getinitiatedMeetingDetail
} from '.';
import { push } from 'connected-react-router';
import { RedirectPage } from 'util/meeting';
import { ApprovalMeetingStatus } from 'constant/approval';

type GetUnreadCountAction = ReturnType<typeof getUnreadCount>;
type GetInitiatedMeetingAction = ReturnType<typeof getInitiatedMeeting>;
type GetReceivedMeetingAction = ReturnType<typeof getReceivedMeeting>;
type GetReceivedMeetingDetailAction = ReturnType<typeof getReceivedMeetingDetail>;

const getUnreadApprovalMeetingEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(getUnreadCount.match),
    mergeMap(() => {
      return Meeting.getUnreadApprovalMeeting().pipe(
        mergeMap((data) => {
          return of(setUnReadCount(data.data));
        }),
        catchError(() => of(setUnReadCount(0)))
      );
    })
  );

const getInitiatedMeetingEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(getInitiatedMeeting.match),
    mergeMap((action) => {
      return Meeting.getInitiatedApprovalMeeting(action.payload).pipe(
        mergeMap((data) => {
          return of(setInitiatedMeetingLoading(false), setInitiatedMeeting(data.data));
        }),
        startWith(setInitiatedMeetingLoading(true)),
        catchError(() => of(setInitiatedMeetingLoading(false)))
      );
    })
  );

const getReceivedMeetingEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(getReceivedMeeting.match),
    mergeMap((action) => {
      return Meeting.getReceivedApprovalMeeting(action.payload).pipe(
        mergeMap((data) => {
          return of(setReceivedMeetingLoading(false), setReceivedMeeting(data.data));
        }),
        startWith(setReceivedMeetingLoading(true)),
        catchError(() => of(setReceivedMeetingLoading(false)))
      );
    })
  );

const getReceivedMeetingDetailEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(getReceivedMeetingDetail.match),
    mergeMap((action) => {
      console.log(action);
      return Meeting.getApprovalMeeting(action.payload).pipe(
        mergeMap((data) => {
          return of(setReceivedMeetingDetail(data.data));
        })
      );
    })
  );

const getinitiatedMeetingDetailEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(getinitiatedMeetingDetail.match),
    mergeMap((action) => {
      console.log(action);
      return Meeting.getApprovalMeeting(action.payload).pipe(
        mergeMap((data) => {
          return of(setInitiatedMeetingDetail(data.data));
        })
      );
    })
  );

const doApprovalMeetingEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(doApprovalMeeting.match),
    mergeMap((action) => {
      const isPass = action.payload.isPass;
      const fn = isPass ? Meeting.setApprovalMeetingPass : Meeting.setApprovalMeetingFail;
      return fn(action.payload.meetingNo, action.payload.meetingAuditRecordId, action.payload.reason).pipe(
        mergeMap(() => {
          return of(getReceivedMeetingDetail(action.payload.meetingNo), appMessageSuccess(APP_MESSAGE.DEFAULT_SUCCESS));
        }),
        catchError((err) => {
          console.log('update err', err);
          if (err.response.data.code === 400405020) {
            return of(getReceivedMeetingDetail(action.payload.meetingNo), appMessageError(APP_MESSAGE.APPROVAL_STATUS_EXPIRED));
          } else {
            return of(getReceivedMeetingDetail(action.payload.meetingNo), appMessageError(APP_MESSAGE.DEFAULT_REJECTED));
          }
        })
      );
    })
  );

const setApprovalMeetingReadEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(setApprovalMeetingRead.match),
    mergeMap((action) => {
      console.log(action);
      return Meeting.setApprovalMeetingRead(action.payload).pipe(
        mergeMap(() => {
          return of(setLocaleApprovalMeetingRead(action.payload), getUnreadCount());
        })
      );
    })
  );

const StatusMessgaeMap = {
  [ApprovalMeetingStatus.Expired]: '此申请已过期',
  [ApprovalMeetingStatus.Revoke]: '此申请已撤销',
  [ApprovalMeetingStatus.Fail]: '此申请未通过审批'
};

const gotoApprovalMeetingDetailEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(gotoApprovalMeetingDetail.match),
    mergeMap((action) => {
      console.log(action);
      return Meeting.getApprovalMeeting(action.payload.id).pipe(
        mergeMap((data) => {
          const status = data.data.status as keyof typeof StatusMessgaeMap;
          if (status !== action.payload.status) {
            return of(appMessageError(StatusMessgaeMap[status]), setInitiatedMeetingDetail(data.data));
          }
          return of(push('/details/' + (data.data.meetingNo || data.data.id) + `?from=${RedirectPage.APPROVAL}`));
        })
      );
    })
  );

export type ApprovalEpicActions = GetUnreadCountAction | GetInitiatedMeetingAction | GetReceivedMeetingAction | GetReceivedMeetingDetailAction;

export default combineEpics(
  getUnreadApprovalMeetingEpic,
  getInitiatedMeetingEpic,
  getReceivedMeetingEpic,
  getReceivedMeetingDetailEpic,
  doApprovalMeetingEpic,
  setApprovalMeetingReadEpic,
  gotoApprovalMeetingDetailEpic,
  getinitiatedMeetingDetailEpic
);
